"use client";

import { CatItem } from "@/types/cat";
import { RarityBadge } from "@/components/shared/RarityBadge";
import { Eye } from "lucide-react";

interface CatCardProps {
  cat: CatItem;
  onClick: () => void;
}

export function CatCard({ cat, onClick }: CatCardProps) {
  return (
    <div
      onClick={onClick}
      className="group relative cursor-pointer overflow-hidden rounded-xl border border-border bg-card transition-all hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10"
    >
      <div className="relative aspect-square">
        <img
          src={cat.image}
          alt={cat.name}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        {cat.imageMissing && (
          <div className="absolute right-2 top-2 rounded bg-black/60 px-2 py-1 text-[10px] text-white">
            Preview
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 transition-opacity group-hover:opacity-100">
          <Eye className="h-8 w-8 text-white" />
        </div>
      </div>
      <div className="p-3">
        <div className="flex items-center justify-between gap-2">
          <p className="truncate font-pixel text-[10px]">{cat.name}</p>
          <RarityBadge rarity={cat.rarity} className="shrink-0 text-[10px]" />
        </div>
        <p className="mt-1 truncate text-xs text-muted-foreground">
          {cat.traits.baseMount}
        </p>
      </div>
    </div>
  );
}
